/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBatteryVerticalCharging2 = createReactComponent("outline", "battery-vertical-charging-2", "IconBatteryVerticalCharging2", [["path", { "d": "M7 18v-11c0 -1.105 .895 -2 2 -2h.5c.276 0 .5 -.224 .5 -.5s.224 -.5 .5 -.5h3c.276 0 .5 .224 .5 .5s.224 .5 .5 .5h.5c1.105 0 2 .895 2 2v1m-10 10c0 1.105 .895 2 2 2h1", "key": "svg-0" }], ["path", { "d": "M12 14h6v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M15 21v-3", "key": "svg-2" }], ["path", { "d": "M13 14v-2.5", "key": "svg-3" }], ["path", { "d": "M17 14v-2.5", "key": "svg-4" }]]);

export { IconBatteryVerticalCharging2 as default };
//# sourceMappingURL=IconBatteryVerticalCharging2.mjs.map
